//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchUtils from '~/mixins/search/search-utils'
import SearchFilters from "~/components/search/search-filters.vue";

export default {
  name: 'SearchFilterModal',
  components: {SearchFilters},
  mixins: [searchUtils]
}
